import { fromPlacementAttribute, fromPlacementId } from '../combination-rules/placementIds'
import { EMBROIDERY_VERSION_V2 } from '../embroideryVersion'

import { deriveNameFromEmbroideryPlacement } from './deriveNameFromEmbroideryPlacement'

// v2 placements are snake_case (`left_chest`); legacy values are already display strings.
export const formatPlacementAttribute = (
  value: string | undefined,
  embroideryVersion: string | undefined
): string | undefined => {
  if (!value || embroideryVersion !== EMBROIDERY_VERSION_V2) return value
  const placementId = fromPlacementAttribute(value)
  return placementId ? deriveNameFromEmbroideryPlacement(fromPlacementId(placementId)) : value
}
